<template>
  <div class="zh-s-goods-box">
    <div class="justify-align">
      <div class="title-box" style="display: inline-block;margin-right: 2vw;">
        <div class="title-txt">{{param.title}}</div>
        <div class="title-box-line"></div>
      </div>
      <!--      <div @click="goSouvenirList" class="right-box" style="color: #A1A0A0;font-size: 3.2vw;">-->
      <!--        更多>-->
      <!--      </div>-->
    </div>
    <div class="goods-wrapper">
      <div class="goods-box" v-for="(item,index) in param.data" :key="index" @click="goDesGoodGift(item.goods_id)">
        <div class="item-box">
          <img class="img-goods" :src="item.goods.image" alt="" />
          <div class="bottom-box-goods">
            <div class="bottom-box-goods-box">
              <div class="goods-title">{{item.brand_name}}</div>
              <div class="goods-hint">{{item.tilte}}</div>
              <div class="arrow-price-box">
                <img :src="require('../../assets/'+appTheme+'/t_title.png')" alt="" class="arrow-price-content-bg">
                <div class="arrow-price-content">
                  <span>促销价:</span><span>￥</span><b>{{item.goods.price}}</b>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "goodsItem",
  props:['param'],
  data(){
    return {
      appTheme:this.$store.state.appTheme
    }
  },
  methods:{
    goDesGoodGift(id){
      console.log(id)
      this.$router.push({path:'/goodDetails',query:{id:id}})
    },
  }
}
</script>

<style lang="scss" scoped>
.title-box{
  display: inline-block;font-size: 32px;color: #1D1D1D;font-weight: bold;margin-left: 24px;
  position: relative;padding: 22px 0 5px;
  .title-txt{
    width: 143px;text-align: center;
  }
  .title-box-line{
    width: 143px;
    height: 15px;
    background: #FEDC32;
    border-radius: 8px;margin-top: -15px;
  }
}
  .zh-s-goods-box{
    margin-bottom: 20px;
    .goods-wrapper{
      display: -ms-flexbox;
      display: flex;
      -ms-flex-wrap: wrap;
      flex-wrap: wrap;
      -ms-flex-align: center;
      align-items: center;
      padding: 0 10px 10px;
    }
    .goods-box{
      width: 50%;
      .item-box{
        padding: 30px 10px 0;
        overflow: hidden;
        .img-goods{
          height: 357px;width: 336px;
          border-top: 5px solid #58b93e;border-left: 5px solid #58b93e;
          border-right:5px solid #58b93e;border-top-right-radius: 10px;
          border-top-left-radius: 10px;


        }
        .bottom-box-goods{
          position: relative;margin-top: -6px;overflow: hidden;
          .bottom-box-goods-bg{
            width: 100%;position: absolute;left: 0;top: 0;
            // height: 100%;
          }
          background-image: url(../../assets/t.png);background-size: 100% 100%;
          .bottom-box-goods-box{
            position: relative;
            .goods-title{
              font-weight: bold;font-size: 28px;
              text-align: center;
              padding: 2px;overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              width: 90%;margin: 0 auto;
            }
            .goods-hint{
              overflow: hidden;font-size: 24px;
              text-overflow: ellipsis;text-align: center;
              white-space: nowrap;padding: 0 10px 2px;letter-spacing: 2px;
              width: 90%;margin: 0 auto 10px;
            }

            .arrow-price-box{
              position: relative;padding-bottom: 30px;
              .arrow-price-content-bg{
                position: absolute;bottom: 25px;width: 70%;display: block;
                left: 14%;
              }
              .arrow-price-content{
                position: relative;z-index: 1;
                width: 90%;color: #c43819;font-weight: bold;text-align: center;font-size: 26px;
                span{
                  font-size: 20px;
                }
              }
            }

          }


        }

      }
    }
  }
</style>
